<template>
  <Modal :title="title" class="clone-template-form medium" @submit="submit">
    <template v-slot:body>
      <div class="position-relative form-group w-100">
        <label class="col-12 p-0 font-weight-bold">Name*</label>
        <input class="form-control" placeholder="Name" type="text" v-model="data.name" />
      </div>
      <div class="position-relative form-group w-100">
        <label class="col-12 p-0 font-weight-bold">Template*</label>
        <Select class="mt-2" source="template/search" field="order" v-model="data.id"></Select>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      data: {
        id: null,
        name: ''
      }
    }
  },
  computed: {
    title() {
      return 'Clone Template'
    },
    action() {
      return 'clone'
    },
    storeId() {
      return this.config?.storeId
    },
    submitUri() {
      return 'template/clone'
    }
  },
  created() {
    this.data = {}
  },
  methods: {
    submit() {
      this.submitForm(this.data, {
        done: (response) => {
          if (!_.isUndefined(response.id)) {
            this.$emit('closeAll')
            this.$emitter.emit('Modal', {
              name: 'template.edit',
              data: {
                _id: response.id
              }
            })
          } else {
            this.$util.notify({
              text: 'Can not clone template!',
              status: 'error'
            })
          }
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
#modal-container {
  .clone-template-form {
    .modal-content {
      overflow: visible;
    }
    .modal-body {
      overflow: visible;
    }
  }
}
</style>
